import { Schema as S } from "effect";

import { defineApi, staticApis } from "../client";
import { ApiKeyList, CreatedApiKey } from "../schemas/integrations";

// v1 calls these inline (Integrations.tsx), not from api.ts.

export const { listApiKeys } = staticApis({
	listApiKeys: ["GET", "/keys", ApiKeyList],
});

export const createApiKey = defineApi("CreateApiKey", {
	args: { description: S.String },
	response: CreatedApiKey,
	request: ({ description }) => ({
		method: "POST",
		path: "/keys",
		body: { description: description || "MCP" },
	}),
});

export const deleteApiKey = defineApi("DeleteApiKey", {
	args: { id: S.String },
	response: S.Unknown,
	request: ({ id }) => ({ method: "DELETE", path: `/keys/${id}` }),
});
